import { render, staticRenderFns } from "./Mails.edit.vue?vue&type=template&id=e5410154&"
import script from "./Mails.edit.vue?vue&type=script&lang=js&"
export * from "./Mails.edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports